import ReceptionImg from "../assets/svg/reception.svg";
import KitchenImg from "../assets/svg/kitchen.svg";
import StorageRoomImg from "../assets/svg/storageroom.svg";
import ServerRoomImg from "../assets/svg/serverroom.svg";
import MeetingRoomImg from "../assets/svg/meetingroom.svg";
import PhoneBoothImg from "../assets/svg/phonebooth.svg";

const supportspaceData = [
  {
    title: "supportspace_reception_title",
    imgSrc: ReceptionImg,
    requiresPeople: false,
    placeholder: 0,
    tooltipText: "supportspace_reception_tooltip",
  },
  {
    title: "supportspace_kitchen_title",
    imgSrc: KitchenImg,
    requiresPeople: false,
    placeholder: 0,
    tooltipText: "supportspace_kitchen_tooltip",
  },
  {
    title: "supportspace_storage_title",
    imgSrc: StorageRoomImg,
    requiresPeople: false,
    placeholder: 0,
    tooltipText: "supportspace_storage_tooltip",
  },
  {
    title: "supportspace_server_title",
    imgSrc: ServerRoomImg,
    requiresPeople: false,
    placeholder: 0,
    tooltipText: "supportspace_server_tooltip",
  },
  {
    title: "supportspace_meeting_title",
    imgSrc: MeetingRoomImg,
    requiresPeople: false,
    placeholder: 0,
    tooltipText: "supportspace_meeting_tooltip",
  },
  {
    title: "supportspace_phonebooth_title",
    imgSrc: PhoneBoothImg,
    requiresPeople: false,
    placeholder: 0,
    tooltipText: "supportspace_phonebooth_tooltip",
  },
];

export default supportspaceData;
